import { useCallback, useState, useContext, useEffect, useRef } from "react";
import { Button } from "primereact/button";
import * as Yup from "yup";
import { TostMsg } from "../../../App";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import { Link, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { useFormik } from "formik";
import {
  AddAssessmentPartFirst,
  GetEmpAssessmentPeriodList,
} from "./PMSService";
import { Dropdown } from "primereact/dropdown";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import AddQuestion from "./Add _Question";
import AddnewEmployee from "./Add_new_Employee";
import { getEmployeeList } from "../EmployeeList/Service/employeeService";

let employeeId;
const AddNewAssessment = () => {
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");

  let toster = useContext(TostMsg);
  let SystemAlerts = JSON.parse(localStorage.getItem("SystemAlerts") || "{}");

  let userPermissions = JSON.parse(localStorage.getItem("Permissions") || "{}");

  const { GUID } = useParams();
  const [EmpAssessmentData, setEmpAssessmentList] = useState([]);
  const [eligibleEmployees, setEligibleEmployees] = useState([]);
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const step = query.get("step");
  const [loading, setLoading] = useState(false);
  const [employeeList, setEmployeeList] = useState(null);
  const [activeTab, setActiveTab] = useState("assessment");
  const stepperRef = useRef(null);

  useEffect(() => {
    getEmployeeIdData();
    if (step !== null) {
      setActiveTab(step);
    } else {
      setActiveTab("assessment");
    }
  }, [step]);

  useEffect(() => {
    if (GUID) {
      getEmpAssessmentPeriodList();
    }
  }, [GUID]);

  async function getEmpAssessmentPeriodList() {
    const body = {
      OrgId: userDetails?.OrgId,
      LoggedInUserId: userDetails?.EmpId,
      OAPGuId: GUID,
      Search: "",
      PageNumber: 1,
      PageSize: 1000,
    };
    try {
      let response = await GetEmpAssessmentPeriodList(body);
      const currentAssessment = response?.Data?.assessmentPresiodResponse[0];
      setEmpAssessmentList(currentAssessment);
      setEligibleEmployees(
        currentAssessment?.eligibleEmployeeList,
      );

      assessmentForm.setValues({
  assessmentPeriodStart: currentAssessment?.From?.split("T")[0] || "",
  assessmentPeriodEnd: currentAssessment?.To?.split("T")[0] || "",
  assessmentStart: currentAssessment?.StartedOn?.split("T")[0] || "",
  assessmentEnd: currentAssessment?.EndedOn?.split("T")[0] || "",
  selfAssessmentLastDate: currentAssessment?.SelfAssesmentClosureDate?.split("T")[0] || "",
  firstReviewerLastDate: currentAssessment?.FirstReviewerClosureDate?.split("T")[0] || "",
  reviewerId: currentAssessment?.EmpId || "",
  title: currentAssessment?.Title || "",
  description: currentAssessment?.Description || "",
});

    } catch (error) {
      toster.current.error(ERROR_LIST?.EmpAssessmentList);
    }
  }

  async function getEmployeeIdData() {
    var params = {
      OrganisationId: userDetails?.OrgId,
      LoggedInEmployeeId: userDetails?.EmpId,
      IsDirectReportOrHierarchy: 0,
      SearchText: "",
      FollowersOnly: 0,
      FollowingsOnly: 0,
      IsExEmployeesAlso: 0,
      pageNumber: 1,
      pageSize: 10000000,
      EmployeeId: 0,
      IsSuggestedOnly: 0,
    };
    setLoading(true);
    try {
      let employeesList = await getEmployeeList(params);
      setEmployeeList(employeesList.Data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }

  const AssessmentValidation = Yup.object().shape({
    assessmentPeriodStart: Yup.string().required(
      "Assessment Period Start date is required.",
    ),
    assessmentPeriodEnd: Yup.string().required(
      "Assessment Period End date is required.",
    ),
    assessmentStart: Yup.string().required("Started date is required."),
    assessmentEnd: Yup.string().required("End date is required."),
    selfAssessmentLastDate: Yup.string().required(
      "Self Assessment closure date is required.",
    ),
    firstReviewerLastDate: Yup.string().required(
      "First reviewer closure date is required.",
    ),
    reviewerId: Yup.string().required("Reviewer is required."), // ✅ fixed
    title: Yup.string().required("Title is required."), // ✅ fixed
    description: Yup.string().nullable(), // ✅ fixed
  });

  const assessmentForm = useFormik({
    initialValues: {
      assessmentPeriodStart: "",
      assessmentPeriodEnd: "",
      assessmentStart: "",
      assessmentEnd: "",
      selfAssessmentLastDate: "",
      firstReviewerLastDate: "",
      reviewerId: "",
      title: "",
      description: "",
    },
    validationSchema: AssessmentValidation,
    onSubmit: async (data) => {
      setLoading(true);
      const body = {
        Id: EmpAssessmentData? EmpAssessmentData?.Id : 0,
        OATId: EmpAssessmentData? EmpAssessmentData?.OATId : 0,
        Title: data?.title,
        Description: data?.description,
        From: data?.assessmentPeriodStart,
        To: data?.assessmentPeriodEnd,
        StartedOn: data?.assessmentStart,
        EndedOn: data?.assessmentEnd,
        SelfAssessmentClosureDate: data?.selfAssessmentLastDate,
        FirstReviewerClosureDate: data?.firstReviewerLastDate,
        ReviewEndDate: "", // data?.title,
        AssessmentPeriodStatusId: EmpAssessmentData? EmpAssessmentData?.AssessmentPeriodStatusId : 0,
        ReviewerBy: data?.reviewerId,
      };
      try {
        await AddAssessmentPartFirst(body);
        // assessmentForm.resetForm();
        // history.push("/Assessment/Employee/Cycles/team");
        // stepperRef.current.nextCallback();
        setActiveTab("question");
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    },
  });

  return (
    <div className="container-fluid">
      <div className="row g-3 assessment-module">
        <div className="col-xl-12">
          <div className="form-head d-flex flex-wrap align-items-center">
            <div className="me-auto">
              <h2 className="font-w600 mb-0">Add New Assessment</h2>
            </div>
            <div className="rightside-tabs">
              {/* <select className='form-control'>
                                           <option disabled>Select Period</option>
                                           <option selected >01 April 2022 - 31 March 2023</option>
                                           <option>01 April 2021 - 31 March 2022</option>
                                           <option>01 April 2020 - 31 March 2021</option>
                                       </select> */}
              <Link to="/AssessmentCycles">
                <button
                  className="cancelbutton w-auto float-right"
                  style={{ minWidth: "fit-content" }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="17"
                    height="17"
                    fill="currentColor"
                    className="bi bi-arrow-left me-2"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"
                    ></path>
                  </svg>
                  Back
                </button>
              </Link>
            </div>
          </div>
        </div>
        <div className="col-xl-9">
          <ul className="assessment-stepper">
            <li
              className={`step ${activeTab === "assessment" ? "active" : ""}`}
              onClick={() => setActiveTab("assessment")}
            >
              <span
                className={`circle ${
                  activeTab === "assessment" ? "filled" : ""
                }`}
              >
                1
              </span>
              <span className="label">Assessment Parameters</span>
            </li>

            <li
              className={`step ${activeTab === "question" ? "active" : ""}`}
              onClick={() => setActiveTab("question")}
            >
              <span
                className={`circle ${activeTab === "question" ? "filled" : ""}`}
              >
                2
              </span>
              <span className="label">Question Setup</span>
            </li>

            <li
              className={`step ${
                activeTab === "employee" ? "active-last" : ""
              }`}
              onClick={() => setActiveTab("employee")}
            >
              <span
                className={`circle ${activeTab === "employee" ? "filled" : ""}`}
              >
                3
              </span>
              <span className="label">Add Employee</span>
            </li>
          </ul>

          <div className="tab-content addnew-assessmentform">
            {activeTab == "assessment" && (
              <div id="assessment" className="show active">
                <form onSubmit={assessmentForm.handleSubmit}>
                  <div className="flex flex-column h-12rem">
                    <div className="border-2 border-dashed surface-border border-round surface-ground flex-auto flex justify-content-center align-items-center font-medium">
                      <div className="row g-4">
                        <div className="col-md-6">
                          <label for="Type" className="form-label-file">
                            Assessment Period Start
                            <i className="inValidError">*</i>
                          </label>
                          <input
                            type="date"
                            className={
                              "form-control" +
                              (assessmentForm.errors.assessmentPeriodStart &&
                              assessmentForm.touched.assessmentPeriodStart
                                ? " is-invalid"
                                : "")
                            }
                            name="assessmentPeriodStart"
                            onClick={(e) =>
                              e.target.showPicker && e.target.showPicker()
                            }
                            onChange={assessmentForm.handleChange}
                            value={
                              assessmentForm.values.assessmentPeriodStart || ""
                            }
                            onBlur={assessmentForm.handleBlur}
                          />
                          <div className="invalid-feedback">
                            {assessmentForm.errors.assessmentPeriodStart &&
                            assessmentForm.touched.assessmentPeriodStart
                              ? assessmentForm.errors.assessmentPeriodStart
                              : null}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <label for="Type" className="form-label-file">
                            Assessment Period End
                            <i className="inValidError">*</i>
                          </label>
                          <input
                            type="date"
                            className={
                              "form-control" +
                              (assessmentForm.errors.assessmentPeriodEnd &&
                              assessmentForm.touched.assessmentPeriodEnd
                                ? " is-invalid"
                                : "")
                            }
                            name="assessmentPeriodEnd"
                            onClick={(e) =>
                              e.target.showPicker && e.target.showPicker()
                            }
                            onChange={assessmentForm.handleChange}
                            onBlur={assessmentForm.handleBlur}
                            value={assessmentForm.values.assessmentPeriodEnd}
                            min={assessmentForm.values.assessmentPeriodStart}
                          />
                          <div className="invalid-feedback">
                            {assessmentForm.errors.assessmentPeriodEnd &&
                            assessmentForm.touched.assessmentPeriodEnd
                              ? assessmentForm.errors.assessmentPeriodEnd
                              : null}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <label for="Type" className="form-label-file">
                            Assessment Start<i className="inValidError">*</i>
                          </label>
                          <input
                            type="date"
                            className={
                              "form-control" +
                              (assessmentForm.errors.assessmentStart &&
                              assessmentForm.touched.assessmentStart
                                ? " is-invalid"
                                : "")
                            }
                            name="assessmentStart"
                            onClick={(e) =>
                              e.target.showPicker && e.target.showPicker()
                            }
                            onChange={assessmentForm.handleChange}
                            value={assessmentForm.values.assessmentStart}
                            min={assessmentForm.values.assessmentPeriodStart}
                            max={assessmentForm.values.assessmentPeriodEnd}
                          />
                          <div className="invalid-feedback">
                            {assessmentForm.errors.assessmentStart &&
                            assessmentForm.touched.assessmentStart
                              ? assessmentForm.errors.assessmentStart
                              : null}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <label for="Type" className="form-label-file">
                            Assessment End<i className="inValidError">*</i>
                          </label>
                          <input
                            type="date"
                            className={
                              "form-control" +
                              (assessmentForm.errors.assessmentEnd &&
                              assessmentForm.touched.assessmentEnd
                                ? " is-invalid"
                                : "")
                            }
                            name="assessmentEnd"
                            onClick={(e) =>
                              e.target.showPicker && e.target.showPicker()
                            }
                            onChange={assessmentForm.handleChange}
                            value={assessmentForm.values.assessmentEnd}
                            min={assessmentForm.values.assessmentStart}
                            max={assessmentForm.values.assessmentPeriodEnd}
                          />
                          <div className="invalid-feedback">
                            {assessmentForm.errors.assessmentEnd &&
                            assessmentForm.touched.assessmentEnd
                              ? assessmentForm.errors.assessmentEnd
                              : null}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <label for="Type" className="form-label-file">
                            Self Assessment Last Date
                            <i className="inValidError">*</i>
                          </label>
                          <input
                            type="date"
                            className={
                              "form-control" +
                              (assessmentForm.errors.selfAssessmentLastDate &&
                              assessmentForm.touched.selfAssessmentLastDate
                                ? " is-invalid"
                                : "")
                            }
                            name="selfAssessmentLastDate"
                            onClick={(e) =>
                              e.target.showPicker && e.target.showPicker()
                            }
                            onChange={assessmentForm.handleChange}
                            value={assessmentForm.values.selfAssessmentLastDate}
                            min={assessmentForm.values.assessmentStart}
                            max={assessmentForm.values.assessmentEnd}
                          />
                          <div className="invalid-feedback">
                            {assessmentForm.errors.selfAssessmentLastDate &&
                            assessmentForm.touched.selfAssessmentLastDate
                              ? assessmentForm.errors.selfAssessmentLastDate
                              : null}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <label for="Type" className="form-label-file">
                            First Reviewer Last Date
                            <i className="inValidError">*</i>
                          </label>
                          <input
                            type="date"
                            className={
                              "form-control" +
                              (assessmentForm.errors.firstReviewerLastDate &&
                              assessmentForm.touched.firstReviewerLastDate
                                ? " is-invalid"
                                : "")
                            }
                            name="firstReviewerLastDate"
                            onClick={(e) =>
                              e.target.showPicker && e.target.showPicker()
                            }
                            onChange={assessmentForm.handleChange}
                            value={assessmentForm.values.firstReviewerLastDate}
                            min={
                              assessmentForm.values.assessmentStart &&
                              assessmentForm.values.selfAssessmentLastDate
                            }
                            max={assessmentForm.values.assessmentEnd}
                          />
                          <div className="invalid-feedback">
                            {assessmentForm.errors.firstReviewerLastDate &&
                            assessmentForm.touched.firstReviewerLastDate
                              ? assessmentForm.errors.firstReviewerLastDate
                              : null}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <label for="Type" className="form-label-file">
                            Reviewer By<i className="inValidError">*</i>
                          </label>
                          <Dropdown
                            value={assessmentForm.values.reviewerId}
                            name="reviewerId"
                            options={employeeList}
                            className={"form-control wide"}
                            onChange={(e) =>
                              assessmentForm.setFieldValue(
                                "reviewerId",
                                e.value,
                              )
                            }
                            optionLabel="FullName"
                            optionValue="EmpId"
                            onBlur={() =>
                              assessmentForm.setFieldTouched("reviewerId", true)
                            }
                          />
                          <div className="invalid-feedback">
                            {assessmentForm.errors.reviewerId &&
                            assessmentForm.touched.reviewerId
                              ? assessmentForm.errors.reviewerId
                              : null}
                          </div>
                        </div>
                        <div className="col-md-6">
                          <label for="Type" className="form-label-file">
                            Title<i className="inValidError">*</i>
                          </label>
                          <input
                            type="text"
                            name="title"
                            className={
                              "form-control" +
                              (assessmentForm.errors.title &&
                              assessmentForm.touched.title
                                ? " is-invalid"
                                : "")
                            }
                            onChange={assessmentForm.handleChange}
                            value={assessmentForm.values.title}
                          />
                          <div className="invalid-feedback">
                            {assessmentForm.errors.title &&
                            assessmentForm.touched.title
                              ? assessmentForm.errors.title
                              : null}
                          </div>
                        </div>
                        <div className="col-md-12">
                          <label for="Type" className="form-label-file">
                            Description<i className="inValidError">*</i>
                          </label>
                          <textarea
                            rows={5}
                            cols={1}
                            name="description"
                            className={"form-control h-auto"}
                            onChange={assessmentForm.handleChange}
                            value={assessmentForm.values.description}
                          />
                          {/* <div className="invalid-feedback">
                           {assessmentForm.errors.description &&
                           assessmentForm.touched.description
                             ? assessmentForm.errors.description
                             : null}
                         </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex pt-5 justify-content-between text-right">
                    {/* <Button
                     label="Save and Exit"
                     className="savebutton w-auto"
                     iconPos="right"
                   /> */}
                    <Button
                      type="submit"
                      label="Save and Continue"
                      className="publish-click w-auto"
                      iconPos="right"
                      // onClick={() => stepperRef.current.nextCallback()}
                    />
                  </div>
                </form>
              </div>
            )}
            {activeTab == "question" && (
              <div id="question" className="show active">
                <AddQuestion submitForm={(value) => setActiveTab(value)} />
              </div>
            )}
            {activeTab == "employee" && (
              <div id="employee" className="show active">
                <AddnewEmployee />
              </div>
            )}
          </div>
        </div>
        <div className="col-xl-3">
          <div className="content">
            <div>
              <h1>About Organization</h1>
              <p>
                Lorem ipsum dolor sit, amet consectetur adipisicing elit. Aut
                praesentium nemo eum exercitationem unde.
              </p>
            </div>
            <img src="/images/pms/assessment.png" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddNewAssessment;
